var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 25,
    viewBox: "0 0 38 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2209_68896)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 0.407227H3C1.3 0.407227 0 1.70723 0 3.40723V21.4072C0 23.1072 1.4 24.4072 3 24.4072H35C36.7 24.4072 38 23.1072 38 21.4072V3.40723C38 1.70723 36.6 0.407227 35 0.407227Z",
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 1.40723C36.1 1.40723 37 2.30723 37 3.40723V21.4072C37 22.5072 36.1 23.4072 35 23.4072H3C1.9 23.4072 1 22.5072 1 21.4072V3.40723C1 2.30723 1.9 1.40723 3 1.40723H35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19.4072C18.866 19.4072 22 16.2732 22 12.4072C22 8.54123 18.866 5.40723 15 5.40723C11.134 5.40723 8 8.54123 8 12.4072C8 16.2732 11.134 19.4072 15 19.4072Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 19.4072C26.866 19.4072 30 16.2732 30 12.4072C30 8.54123 26.866 5.40723 23 5.40723C19.134 5.40723 16 8.54123 16 12.4072C16 16.2732 19.134 19.4072 23 19.4072Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 12.407C22 10.007 20.8 7.90703 19 6.70703C17.2 8.00703 16 10.107 16 12.407C16 14.707 17.2 16.907 19 18.107C20.8 16.907 22 14.807 22 12.407Z",
    fill: "#FF5F00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2209_68896"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    fill: "white",
    transform: "translate(0 0.407227)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.efc7808f717c4b0b9550e7b57324b0ad.svg";
export { ForwardRef as ReactComponent };